<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>
  <!-- Page Wrapper -->
  <div class="page-wrapper">
    <div class="content">
      <!-- Breadcrumb -->
      <div
        class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3"
      >
        <breadcrumb :title="title" :text="text" :text1="text1" />
        <div class="head-icons ms-2">
          <a
            href="javascript:void(0);"
            class=""
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            data-bs-original-title="Collapse"
            id="collapse-header"
            @click="toggleHeader"
          >
            <i class="ti ti-chevrons-up"></i>
          </a>
        </div>
      </div>
      <!-- /Breadcrumb -->

      <settings-tab></settings-tab>
      <div class="row">
        <others-sidebar></others-sidebar>
        <div class="col-xl-9">
          <div class="card">
            <div class="card-body pb-0">
              <div class="border-bottom mb-3 pb-3">
                <h4>Storage</h4>
                <p class="text-muted mb-0 fs-12">
                  Choose where this company’s files (avatars, documents, etc.)
                  are stored. Local is recommended for development or small
                  setups, AWS S3 for scalable, secure cloud storage.
                </p>
              </div>
              <div class="row">
                <!-- Local Storage -->
                <div class="col-md-6">
                  <div class="card">
                    <div class="card-body">
                      <div
                        class="d-flex align-items-center justify-content-between"
                      >
                        <div class="d-flex align-items-center">
                          <span
                            class="avatar avatar-lg bg-gray-100 me-2 flex-shrink-0"
                          >
                            <img
                              src="@/assets/img/icons/storage-icon-03.svg"
                              class="w-auto h-auto"
                              alt="Img"
                            />
                          </span>
                          <div>
                            <h5 class="mb-0">Local Storage</h5>
                            <small class="text-muted">
                              Files are stored on this server.
                            </small>
                          </div>
                        </div>
                        <div class="d-flex align-items-center">
                          <a
                            href="javascript:void(0);"
                            class="btn btn-icon btn-sm me-2"
                          >
                            <i class="ti ti-settings fs-20"></i>
                          </a>
                          <div class="form-check form-check-md form-switch">
                            <input
                              class="form-check-input me-2"
                              type="checkbox"
                              role="switch"
                              :checked="driver === 'local'"
                              @change="setDriver('local')"
                              :disabled="loading"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- AWS -->
                <div class="col-md-6">
                  <div class="card">
                    <div class="card-body">
                      <div
                        class="d-flex align-items-center justify-content-between"
                      >
                        <div class="d-flex align-items-center">
                          <span
                            class="avatar avatar-lg bg-gray-100 me-2 flex-shrink-0"
                          >
                            <img
                              src="@/assets/img/icons/aws.svg"
                              class="w-auto h-auto"
                              alt="Img"
                            />
                          </span>
                          <div>
                            <h5 class="mb-0">AWS</h5>
                            <small class="text-muted">
                              Store files in Amazon S3.
                            </small>
                          </div>
                        </div>
                        <div class="d-flex align-items-center">
                          <a
                            href="javascript:void(0);"
                            class="btn btn-icon btn-sm me-2"
                            data-bs-toggle="modal"
                            data-bs-target="#aws_settings"
                          >
                            <i class="ti ti-settings fs-20"></i>
                          </a>
                          <div class="form-check form-check-md form-switch">
                            <input
                              class="form-check-input me-2"
                              type="checkbox"
                              role="switch"
                              :checked="driver === 's3'"
                              @change="setDriver('s3')"
                              :disabled="loading"
                            />
                          </div>
                        </div>
                      </div>
                      <p class="mt-2 mb-0 text-muted fs-12">
                        When enabled, files (avatars, documents, etc.) will be
                        stored on AWS S3 using the configuration below.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <p v-if="loading" class="text-muted mt-2 mb-3">
                Loading storage settings...
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
     <div
      class="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3"
    >
      <p class="mb-0">2014 - {{ new Date().getFullYear() }} &copy; DoneQuick HR & Payroll</p>
      <p>
        Powered by <a href="#" @click.prevent class="text-primary">DoneQuick Technological World</a>
      </p>
    </div>
  </div>
  <!-- /Page Wrapper -->

  <!-- AWS Settings Modal -->
  <div class="modal fade" id="aws_settings">
    <div class="modal-dialog modal-dialog-centered modal-md">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">AWS</h4>
          <button
            type="button"
            class="btn-close custom-btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <i class="ti ti-x"></i>
          </button>
        </div>
        <form @submit.prevent="handleSaveAws">
          <div class="modal-body pb-0">
            <div class="row">
              <div class="col-md-12">
                <div class="mb-3">
                  <label class="form-label">AWS Access Key</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="awsForm.access_key"
                    :class="{ 'is-invalid': errors.access_key }"
                  />
                  <div v-if="errors.access_key" class="invalid-feedback">
                    {{ errors.access_key }}
                  </div>
                </div>
              </div>

              <div class="col-md-12">
                <div class="mb-3">
                  <label class="form-label">AWS Secret Key</label>
                  <input
                    type="password"
                    class="form-control"
                    v-model="awsForm.secret_key"
                    autocomplete="new-password"
                    :class="{ 'is-invalid': errors.secret_key }"
                  />
                  <small class="text-muted">
                    Leave blank to keep the existing secret key.
                  </small>
                  <div v-if="errors.secret_key" class="invalid-feedback">
                    {{ errors.secret_key }}
                  </div>
                </div>
              </div>

              <div class="col-md-12">
                <div class="mb-3">
                  <label class="form-label">Bucket Name</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="awsForm.bucket"
                    :class="{ 'is-invalid': errors.bucket }"
                  />
                  <div v-if="errors.bucket" class="invalid-feedback">
                    {{ errors.bucket }}
                  </div>
                </div>
              </div>

              <div class="col-md-12">
                <div class="mb-3">
                  <label class="form-label">Region</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="awsForm.region"
                    :class="{ 'is-invalid': errors.region }"
                  />
                  <div v-if="errors.region" class="invalid-feedback">
                    {{ errors.region }}
                  </div>
                </div>
              </div>

              <div class="col-md-12">
                <div class="mb-3">
                  <label class="form-label">AWS Base URL</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="awsForm.base_url"
                    placeholder="https://your-bucket.s3.amazonaws.com"
                  />
                  <small class="text-muted">
                    Optional: used when generating file URLs.
                  </small>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-light me-2"
              data-bs-dismiss="modal"
            >
              Cancel
            </button>
            <button type="submit" class="btn btn-primary" :disabled="saving">
              <span
                v-if="saving"
                class="spinner-border spinner-border-sm me-1"
              />
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
  <!-- /AWS Modal -->
</template>

<script setup>
import { computed, reactive, ref, onMounted } from "vue";
import { Modal } from "bootstrap";
import { useStorageSettingsStore } from "@/stores/settings/storage.store";

const title = "Settings";
const text = "Administration";
const text1 = "Settings";

const storageStore = useStorageSettingsStore();

const loading = computed(() => storageStore.loading);
const driver = computed(() => storageStore.driver);
const aws = computed(() => storageStore.aws);

const saving = ref(false);

const errors = reactive({
  access_key: "",
  secret_key: "",
  bucket: "",
  region: "",
  base_url: "",
});

function validateAwsForm() {
  errors.access_key = "";
  errors.secret_key = "";
  errors.bucket = "";
  errors.region = "";
  errors.base_url = "";

  let ok = true;

  if (!awsForm.access_key?.trim()) {
    errors.access_key = "AWS Access Key is required.";
    ok = false;
  }
  // For a brand new config, require secret key.
  // If you later want to allow updating without changing it, this is already handled:
  if (!awsForm.secret_key?.trim()) {
    errors.secret_key = "AWS Secret Key is required.";
    ok = false;
  }
  if (!awsForm.bucket?.trim()) {
    errors.bucket = "Bucket Name is required.";
    ok = false;
  }
  if (!awsForm.region?.trim()) {
    errors.region = "Region is required.";
    ok = false;
  }

  return ok;
}

const awsForm = reactive({
  access_key: "",
  secret_key: "",
  bucket: "",
  region: "",
  base_url: "",
});

function toggleHeader() {
  document.getElementById("collapse-header").classList.toggle("active");
  document.body.classList.toggle("header-collapse");
}

async function setDriver(newDriver) {
  if (driver.value === newDriver) return;
  await storageStore.setDriver(newDriver);
}

/**
 * Close AWS modal and clean any leftover Bootstrap backdrops
 */
function closeAwsModal() {
  const modalEl = document.getElementById("aws_settings");
  if (modalEl) {
    const instance = Modal.getInstance(modalEl) || new Modal(modalEl);
    instance.hide();
  }

  // Fallback cleanup in case any backdrop is left hanging
  document.querySelectorAll(".modal-backdrop").forEach((el) => el.remove());
  document.body.classList.remove("modal-open");
  document.body.style.removeProperty("padding-right");
}

async function handleSaveAws() {
  if (!validateAwsForm()) {
    return;
  }

  saving.value = true;
  try {
    await storageStore.saveAwsSettings({
      access_key: awsForm.access_key,
      // IMPORTANT: do not send empty string, so we don't wipe the key.
      secret_key: awsForm.secret_key || undefined,
      bucket: awsForm.bucket,
      region: awsForm.region,
      base_url: awsForm.base_url,
    });

    // Clear secret in the form for security
    awsForm.secret_key = "";

    // Close modal + remove backdrops
    closeAwsModal();
  } finally {
    saving.value = false;
  }
}

onMounted(async () => {
  await storageStore.fetchSettings();

  // Initialize form from store values
  awsForm.access_key = aws.value.access_key || "";
  awsForm.bucket = aws.value.bucket || "";
  awsForm.region = aws.value.region || "";
  awsForm.base_url = aws.value.base_url || "";
  awsForm.secret_key = ""; // never pre-fill
});
</script>


